
import XHeader from 'vux/src/components/x-header/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import Drawer from 'vux/src/components/drawer/index.vue'
import Group from 'vux/src/components/group/index.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XImg from 'vux/src/components/x-img/index.vue'

import both from './assets/both.jpeg';

export default {
created() {

document.documentElement.style.fontSize = `${window.innerWidth / 25}px`;

this.setTabbarIndex();
if (this.routesArr.some(elem => elem === this.$route.path)) this.showBack = false;
else this.showBack = true;
},
mounted() {

document.getElementById('app').style.height = `${document.body.offsetHeight}px`;
this.heightData = `${document.body.offsetHeight - this.$refs.header.$el.offsetHeight - this.$refs.tabbar.$el.offsetHeight}px`;
},
directives: {
TransferDom
},
components: {
XHeader,
Tabbar,
TabbarItem,
Drawer,
Group,
GroupTitle,
XInput,
XButton,
XImg
},
data() {
return {
title: '',
index: 0,
routeViewHeight: '',
heightData: '',
showBack: false,
routesArr: ['/in_theaters', '/coming_soon', '/top250', '/us_box', '/search', '/moviedetail', '/celebrity'],
showModeValue: 'push',
showPlacementValue: 'left',
both,
movienameVal: '',
movietypeVal: '',
drawerVisibility: false
}
},
methods: {

changeText(index) {
if (index >= 0 && index <= 3) this.title = this.$refs[`tabbarItem${index}`].innerText;
else if (index === 4) this.title = '电影搜索结果';
else if (index === 5) this.title = '电影详情';
else if (index === 6) this.title = '影人详情';
},

setTabbarIndex() {
this.routesArr.forEach((item, index) => {
if (new RegExp(item).test(this.$route.path)) {
this.index = index;
}
}, this);
},

showDrawer() {
this.drawerVisibility = true;

setTimeout(() => {
this.$refs.moviename.focus();
}, 250);
},

submit() {
if (this.movienameVal.trim() === '' && this.movietypeVal.trim() === '') {
this.$vux.toast.show({
text: '不能为空',
type: 'warn',
position: 'middle'
});
} else {
this.$router.push({ path: '/search', query: { q: this.movienameVal, tag: this.movietypeVal } });
this.$store.commit('changeIsSearch');
}
},

changeDrawerVisibility() {
this.drawerVisibility = !this.drawerVisibility;
}
},
watch: {

$route(newval) {
this.setTabbarIndex();
if (this.routesArr.some(elem => elem === newval.path)) this.showBack = false;
else this.showBack = true;
},

drawerVisibility(newval) {
if (newval === false) {
this.movienameVal = '';
this.movietypeVal = '';
}
}
}
}



// WEBPACK FOOTER //
// ./src/App.vue